import { Link } from '@tanstack/react-router';
import { SearchX } from 'lucide-react';

import { StateBlock } from './StateBlock';

export function NotFound() {
  return (
    <StateBlock
      icon={SearchX}
      title="Not found"
      description="That entity does not exist, or it was deleted. If you followed a deep link from an alert, the record may have been removed since."
      actions={
        <Link
          to="/"
          className="border-bd-s bg-elev text-tx hover:bg-high rounded-md border px-3 py-1.5 text-[13px] font-medium no-underline hover:no-underline"
        >
          Back to dashboard
        </Link>
      }
    />
  );
}
